export default __webpack_public_path__ + "media/images/clippy_wave-afb828463da264adbce26a3f17731f6c.gif";